import Axios from "@/plugins/Axios";
// import store from "@/store";
import GestaoDeAula from "@/Models/GestaoDeAula";
import Aula from "@/Models/Aula";

export class GestoesDeAulasAEEService {
  async syncAll(pageNumber, query) {
    const response = await Axios().get(`gestoes-de-aulas-aee?page=${pageNumber}&query=${query}`);
    return response.data;
  }

  async visualizarTurma(gestaoDeAula) {
    const response = await Axios().get(`gestoes-de-aulas-aee/${gestaoDeAula}/visualizar/turma`);
    return response.data;
  }

  async listarAulasGestao(gestaoDeAulaId) {
    const response = await Axios().post("gestoes-de-aulas-aee/listar-aulas-gestao", {
      gestao_id: gestaoDeAulaId,
    });
    const aulas = response.data.gestaoDeAula.aulas.map((aulas) => new Aula(aulas));
    const payload = response.data;
    return { aulas, payload };
  }

  async listarAulasIntervaloData(gestaoDeAulaId, intervalo) {
    const response = await Axios().post("gestoes-de-aulas-aee/listar-aulas-intervalo-datas", {
      gestao_id: gestaoDeAulaId,
      intervalo,
    });
    const aulas = response.data.gestaoDeAula.aulas.map((aulas) => new Aula(aulas));
    const payload = response.data;
    return { aulas, payload };
  }

  async listarAulasDaGestaoPaginate(gestaoDeAulaId, pageNumber = 0, query = "") {
    const response = await Axios().post(
      `gestoes-de-aulas-aee/listar-aulas-da-gestao-paginate?page=${pageNumber}&query=${query}`,
      {
        gestao_id: gestaoDeAulaId,
      }
    );
    const aulas = response.data.aulas.data.map((aulas) => new Aula(aulas));
    const data = response.data.aulas;
    const payload = response.data;
    return { aulas, payload, data };
  }

  async visualizar(gestaoDeAula) {
    const response = await Axios().get(`gestoes-de-aulas-aee/${gestaoDeAula}/visualizar`);
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async gestaoGeralId(gestaoDeAulaId) {
    const filtro = true;
    const response = await Axios().get(
      `gestoes-de-aulas-aee/${gestaoDeAulaId}/visualizar/${filtro}`
    );
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async geral() {
    const response = await Axios().get(`gestoes-de-aulas-aee/geral`);
    const gestoesDeAulasGeral = response.data.map(
      (gestaoDeAulas) => new GestaoDeAula(gestaoDeAulas)
    );
    // store.commit("GestoesDeAulas/setGestoesDeAulas", gestoesDeAulasGeral);

    return gestoesDeAulasGeral;
  }

  async geralPaginate(pageNumber, query) {
    const response = await Axios().get(
      `gestoes-de-aulas-aee/geral?page=${pageNumber}&query=${query}`
    );

    return response.data;
  }

  async listarGestoesProfessor(gestao) {
    const response = await Axios().post(`gestoes-de-aulas-aee/listar-gestoes-professor`, {
      gestao,
    });
    return response.data;
  }

  async listarGestaoDeAulasDaTurma(turma_id) {
    const response = await Axios().post(`gestoes-de-aulas-aee/listar-gestoes-aulas-turma`, {
      turma_id,
    });
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async criar(relacoesList) {
    const response = await Axios().post("gestoes-de-aulas-aee", relacoesList);
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async atualizar(gestaoDeAulas) {
    const response = await Axios().put(`gestoes-de-aulas-aee/${gestaoDeAulas.id}`, gestaoDeAulas);
    const gestaoDeAulasAtualizada = response.data;
    // store.commit("GestoesDeAulas/atualizarGestaoDeAula", gestaoDeAulasAtualizada);
    return gestaoDeAulasAtualizada;
  }

  async deletarGestaoDeAula(turma) {
    const response = await Axios().delete(`gestoes-de-aulas-aee/${turma.id}`);
    const gestaoDeAulasDeletada = response.data;
    // store.commit("GestoesDeAulas/deletarGestaoDeAula", gestaoDeAulas.id);
    return gestaoDeAulasDeletada;
  }
}
export default new GestoesDeAulasAEEService();
